import { Spinner } from "../Spinner";
import { useState } from "react";
import { Card, Field } from "../area";
import { slugFromName } from "../../lib/shop";

/** The two things a product needs to exist: a name and its web address. It starts hidden. */
export function NewProductForm({ busy, onCancel, onCreate }: { busy: boolean; onCancel: () => void; onCreate: (name: string, slug: string) => void }) {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  return <form aria-busy={busy} onSubmit={(event) => { event.preventDefault(); if (!busy) onCreate(name, slug); }}>
    <fieldset className="bw-shop-locked" disabled={busy}><Card title="New product" description="Starts hidden. Make it available when you're ready.">
      <Field label="Name"><input autoFocus required maxLength={160} value={name} onChange={(event) => { setName(event.target.value); setSlug(slugFromName(event.target.value)); }} /></Field>
      <Field label="Product address"><input required pattern="[a-z0-9]+(-[a-z0-9]+)*" value={slug} onChange={(event) => setSlug(event.target.value)} /></Field>
      <div className="bw-actions">
        <button type="button" className="bw-btn bw-btn--quiet" onClick={onCancel}>Cancel</button>
        <button className="bw-btn bw-btn--primary bw-btn--action" disabled={busy}>{busy ? <><Spinner /> Creating…</> : "Create product"}</button>
      </div>
    </Card></fieldset>
  </form>;
}
